/*
  KP: product page option picker.

  Runs on product pages and puts a nicer front on the theme's own option selects, which
  stay in place (hidden). Each option gets one of these, decided by what it holds:

    - Dropdown      the "Model" option, or any option with more than 12 values.
                    A search box appears when there are more than 8 values.
    - Picture cards an option whose values have a photo in CARDS below
                    (phone case types, power bank options, ring holder options).
                    Each card shows the price of that choice.
    - Text buttons  any other option with 2 to 12 values (print sizes, frame types).
    - Nothing       an option with a single value.

  A choice is shown straight away (picker, price, main photo, title), then the theme's
  selects are set and their normal change event is fired, so the theme does the real work
  in the background (variant, add to cart, gallery) exactly as it would for its own picker.

  The theme re-draws the picker area after every change, so this script re-builds its front
  each time that happens.

  It also adds the selected choices to the product title, last option first, for example
  "Curious Geese Checkered Phone Case - Tough Case - iPhone 18 Pro Max". This replaces the
  Variant Title King app. Set TITLE_SUFFIX to false to switch it off.

  To change a card photo or badge, or to give another option value a photo, edit CARDS.
*/
(function () {
  var FILES = 'https://cdn.shopify.com/s/files/1/0661/9398/1653/files/';
  var SIZE = '?width=250&height=250';

  // Option value -> card photo (and optional badge).
  var CARDS = {
    'Snap Case': { image: FILES + '1774580040.png' + SIZE },
    'Tough Case': { image: FILES + '1774580049.png' + SIZE, badge: 'MOST POPULAR' },
    'Magsafe Tough Case': { image: FILES + '1774580058.png' + SIZE },
    'Power Bank & Shell': { image: FILES + '1780412350.png' + SIZE },
    'Shell Only': { image: FILES + '1780412357.png' + SIZE },
    'Magnetic Ring Holder': { image: FILES + '1779458244.jpg' + SIZE },
    'Magnetic Ring Holder + Metal Mount': { image: FILES + '1779458250.jpg' + SIZE }
  };
  // Cards for these values are shown in this order; other values keep the product's order.
  var CARD_ORDER = ['Snap Case', 'Tough Case', 'Magsafe Tough Case'];
  // Options whose card photos are not square (everything else is shown square, in full).
  var TALL_PHOTO_OPTIONS = ['Case Type'];
  // Tried first when the chosen combination does not exist (a model without MagSafe).
  var FALLBACKS = ['Tough Case'];
  var GROUPS = [['iPhone', 'iPhone'], ['Galaxy', 'Samsung'], ['Pixel', 'Google Pixel'], ['Xiaomi', 'Xiaomi'], ['Oneplus', 'OnePlus'], [null, 'Other']];
  var DROPDOWN_OVER = 12;
  var SEARCH_OVER = 8;
  // Add the selected choices to the product title. Switched off 16 Oct 2026 (Sana: "remove
  // the model and case type that come after"): the title is the product's own name, and
  // the choices show in the picker under it. Set back to true to bring the suffix back.
  var TITLE_SUFFIX = false;
  var TITLE_SEPARATOR = ' - ';
  var API = '/api/2025-07/graphql.json';
  var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;
  var mapCache = {};
  var openBox = null;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function withSeparators(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function money(amount) {
    var format = window.theme && window.theme.moneyFormat;
    var value = parseFloat(amount);

    if (!format || isNaN(value) || !MONEY_TOKEN.test(format)) return '';

    return format.replace(MONEY_TOKEN, function (match, type) {
      switch (type) {
        case 'amount_no_decimals':
          return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withSeparators(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return withSeparators(value, 0, ' ', ',');
        case 'amount_with_space_separator':
          return withSeparators(value, 2, ' ', ',');
        default:
          return withSeparators(value, 2, ',', '.');
      }
    });
  }

  function plainMoney(amount) {
    var holder = document.createElement('span');
    holder.innerHTML = money(amount);
    return holder.textContent;
  }

  function groupOf(name) {
    for (var i = 0; i < GROUPS.length; i++) {
      if (GROUPS[i][0] === null || name.indexOf(GROUPS[i][0]) > -1) return GROUPS[i][1];
    }
    return '';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  // ---- The product's options, read from the theme's selects ----

  function kindOf(name, values) {
    if (values.length <= 1) return 'hidden';
    if (name === 'Model' || values.length > DROPDOWN_OVER) return 'dropdown';

    var hasPhoto = values.some(function (value) {
      return !!CARDS[value];
    });

    return hasPhoto ? 'cards' : 'pills';
  }

  function optionsOf(wrapper) {
    var list = [];

    each(wrapper.querySelectorAll('select[name^="options["]'), function (select) {
      var match = select.name.match(/^options\[(.+)\]$/);
      if (!match) return;

      var number = parseInt(String(select.getAttribute('data-index') || select.id || '').replace(/\D/g, ''), 10);
      var values = Array.prototype.map.call(select.options, function (option) {
        return option.value;
      });

      list.push({
        select: select,
        name: match[1],
        key: 'option' + (isNaN(number) ? list.length + 1 : number),
        values: values,
        kind: kindOf(match[1], values),
        row: select.closest('.product__option') || select.parentNode
      });
    });

    return list;
  }

  function selectionOf(options) {
    return options.map(function (option) {
      return option.select.value;
    });
  }

  // The theme prints the product's variants in the page, but only the first 250.
  function variantsOf(wrapper) {
    if (wrapper.kpVariants) return wrapper.kpVariants;

    var list = [];
    var script = wrapper.querySelector('script[data-variant-json]');

    try {
      list = JSON.parse(script.textContent) || [];
    } catch (e) {}

    if (!Array.isArray(list)) list = [];
    wrapper.kpVariants = list;
    return list;
  }

  function cacheKey(options, selection, index) {
    return productHandle() + '|' + index + '|' + selection.map(function (value, k) {
      return k === index ? '*' : value;
    }).join('|');
  }

  // For one option, what each of its values would give with the rest of the selection
  // kept as it is: { value: { price, compare, image, available } }. Values that do not
  // exist as a variant are left out. Returns null when the page cannot tell.
  function mapNow(wrapper, options, selection, index) {
    var key = cacheKey(options, selection, index);
    if (mapCache[key]) return mapCache[key];

    var variants = variantsOf(wrapper);
    var cutOff = variants.length >= 250;
    var last = variants.length ? variants[variants.length - 1] : null;
    var touchesLast = false;
    var map = {};
    var found = false;

    variants.forEach(function (variant) {
      for (var k = 0; k < options.length; k++) {
        if (k !== index && variant[options[k].key] !== selection[k]) return;
      }

      found = true;
      if (variant === last) touchesLast = true;

      map[variant[options[index].key]] = {
        price: variant.price / 100,
        compare: variant.compare_at_price ? variant.compare_at_price / 100 : 0,
        image: variant.featured_image && variant.featured_image.src ? variant.featured_image.src : '',
        available: variant.available
      };
    });

    // With a cut-off list, a combination at the cut-off point or past it may be incomplete.
    if (cutOff && (!found || touchesLast)) return null;

    mapCache[key] = map;
    return map;
  }

  function mapLater(wrapper, options, selection, index) {
    var now = mapNow(wrapper, options, selection, index);
    if (now) return Promise.resolve(now);

    var handle = productHandle();
    var key = cacheKey(options, selection, index);
    var values = options[index].values;

    if (!handle || !values.length) return Promise.resolve(null);

    var fields = values.map(function (value, n) {
      var chosen = options.map(function (option, k) {
        return '{ name: ' + JSON.stringify(option.name) + ', value: ' + JSON.stringify(k === index ? value : selection[k]) + ' }';
      });

      return 'v' + n + ': variantBySelectedOptions(selectedOptions: [' + chosen.join(', ') + ']) { availableForSale price { amount } compareAtPrice { amount } image { url } }';
    });
    var query = 'query ($h: String!, $c: CountryCode) @inContext(country: $c) { product(handle: $h) { ' + fields.join(' ') + ' } }';

    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: { h: handle, c: (window.Shopify && window.Shopify.country) || null } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var product = json && json.data && json.data.product;
        if (!product) return null;

        var map = {};
        values.forEach(function (value, n) {
          var variant = product['v' + n];
          if (!variant) return;

          map[value] = {
            price: parseFloat(variant.price.amount),
            compare: variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) : 0,
            image: variant.image && variant.image.url ? variant.image.url : '',
            available: variant.availableForSale
          };
        });

        mapCache[key] = map;
        return map;
      })
      .catch(function () {
        return null;
      });
  }

  // ---- Product title ----

  // "<product title> - <last option> - ... - <first option>", as Variant Title King did.
  function setTitle(wrapper, selection) {
    if (!TITLE_SUFFIX || !productHandle()) return;

    var product = wrapper.closest('.product');
    var heading = product ? product.querySelector('h1.product__title') : null;
    var meta = document.querySelector('meta[property="og:title"]');
    var base = meta && meta.content ? meta.content.trim() : '';

    if (!heading || !base) return;

    var parts = selection.filter(function (value) {
      return value && value !== 'Default Title' && base.toLowerCase().indexOf(String(value).toLowerCase()) === -1;
    }).reverse();
    var text = [base].concat(parts).join(TITLE_SEPARATOR);

    if (heading.textContent.trim() !== text) heading.textContent = text;
  }

  // ---- Cards and text buttons ----

  function orderedValues(option) {
    var first = CARD_ORDER.filter(function (value) {
      return option.values.indexOf(value) > -1;
    });
    var rest = option.values.filter(function (value) {
      return first.indexOf(value) < 0;
    });

    return first.concat(rest);
  }

  function drawValues(holder, option, selected, map) {
    var asCards = option.kind === 'cards';

    holder.innerHTML = '';

    orderedValues(option).forEach(function (value) {
      var detail = map ? map[value] : undefined;

      // Leave out choices that do not exist with the rest of the selection (once we know).
      if (map && !detail && value !== selected) return;

      var button = el('button', asCards ? 'kp-pp__card' : 'kp-pp__pill');
      button.type = 'button';
      button.setAttribute('data-kp-pp-value', value);
      button.setAttribute('aria-pressed', value === selected ? 'true' : 'false');
      if (value === selected) button.classList.add('is-selected');
      if (detail && detail.available === false) button.classList.add('is-soldout');

      if (!asCards) {
        button.textContent = value;
        holder.appendChild(button);
        return;
      }

      var card = CARDS[value] || {};
      var image = el('span', 'kp-pp__card-image');
      if (card.image) image.style.backgroundImage = 'url("' + card.image + '")';
      button.appendChild(image);

      if (card.badge) button.appendChild(el('span', 'kp-pp__card-badge', card.badge));

      button.appendChild(el('span', 'kp-pp__card-name', value));

      // Was-price above the price when the variant is on sale, like the old picker.
      if (detail && detail.compare > detail.price) {
        var compare = el('span', 'kp-pp__card-compare');
        compare.innerHTML = money(detail.compare);
        button.appendChild(compare);
      }

      var price = el('span', 'kp-pp__card-price');
      if (detail) price.innerHTML = money(detail.price);
      button.appendChild(price);

      holder.appendChild(button);
    });
  }

  function holderOf(wrapper, index) {
    return wrapper.querySelector('[data-kp-pp-values][data-kp-pp-opt="' + index + '"]');
  }

  function refreshValues(wrapper, options, index) {
    var holder = holderOf(wrapper, index);
    if (!holder) return;

    var selection = selectionOf(options);
    var map = mapNow(wrapper, options, selection, index);

    drawValues(holder, options[index], selection[index], map);

    if (!map) {
      mapLater(wrapper, options, selection, index).then(function (later) {
        var fresh = optionsOf(wrapper);
        var freshHolder = holderOf(wrapper, index);
        if (!later || !freshHolder || !fresh[index]) return;
        if (selectionOf(fresh).join('|') !== selection.join('|')) return;
        drawValues(freshHolder, fresh[index], selection[index], later);
      });
    }
  }

  // ---- Dropdown list ----

  function optionButtons(box) {
    return Array.prototype.slice.call(box.querySelectorAll('[data-kp-pp-pick]'));
  }

  function setActive(box, index) {
    var list = box.querySelector('[data-kp-pp-list]');
    var buttons = optionButtons(box);

    if (!list || !buttons.length) {
      box.kpActive = -1;
      return;
    }

    box.kpActive = Math.max(0, Math.min(index, buttons.length - 1));

    buttons.forEach(function (button, i) {
      button.classList.toggle('is-active', i === box.kpActive);
    });

    var active = buttons[box.kpActive];
    var top = active.offsetTop;
    var bottom = top + active.offsetHeight;

    if (top < list.scrollTop) list.scrollTop = top - 8;
    else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight + 8;
  }

  function drawList(wrapper, box, query) {
    var options = optionsOf(wrapper);
    var option = options[parseInt(box.getAttribute('data-kp-pp-opt'), 10)];
    var list = box.querySelector('[data-kp-pp-list]');
    if (!option || !list) return;

    var typed = query.trim().toLowerCase();
    var words = typed.split(/\s+/).filter(Boolean);
    var count = 0;
    var exact = -1;

    // Brand headings only when the values really fall into more than one brand.
    var groups = GROUPS.filter(function (group) {
      return option.values.some(function (value) {
        return groupOf(value) === group[1];
      });
    });
    var showHeadings = groups.length > 1;
    var lastGroup = null;

    list.innerHTML = '';

    groups.forEach(function (group) {
      option.values.forEach(function (name) {
        if (groupOf(name) !== group[1]) return;

        var haystack = (name + ' ' + (showHeadings ? group[1] : '')).toLowerCase();
        var match = words.every(function (word) {
          return haystack.indexOf(word) > -1;
        });

        if (!match) return;

        if (showHeadings && lastGroup !== group[1]) {
          list.appendChild(el('div', 'kp-pp__group', group[1]));
          lastGroup = group[1];
        }

        var button = el('button', 'kp-pp__option', name);
        button.type = 'button';
        button.setAttribute('role', 'option');
        button.setAttribute('data-kp-pp-pick', name);
        button.setAttribute('aria-selected', name === option.select.value ? 'true' : 'false');
        list.appendChild(button);

        // "iphone 17 pro" should land on iPhone 17 Pro, not iPhone 17 Pro Max above it.
        if (name.toLowerCase() === typed) exact = count;
        count++;
      });
    });

    if (!count) list.appendChild(el('div', 'kp-pp__empty', 'Nothing found'));

    box.kpActive = -1;
    list.scrollTop = 0;
    if (words.length && count) setActive(box, exact > -1 ? exact : 0);
  }

  function closePanel(returnFocus) {
    var box = openBox;
    if (!box) return;

    var panel = box.querySelector('[data-kp-pp-panel]');
    var button = box.querySelector('[data-kp-pp-open]');

    if (panel) panel.hidden = true;
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      if (returnFocus) button.focus();
    }

    openBox = null;
  }

  function openPanel(wrapper, box) {
    var panel = box.querySelector('[data-kp-pp-panel]');
    var button = box.querySelector('[data-kp-pp-open]');
    var search = box.querySelector('[data-kp-pp-search]');
    var list = box.querySelector('[data-kp-pp-list]');
    if (!panel || !button || !list) return;

    closePanel(false);
    openBox = box;
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    if (search) search.value = '';
    drawList(wrapper, box, '');

    var selected = list.querySelector('[aria-selected="true"]');
    if (selected) list.scrollTop = Math.max(0, selected.offsetTop - 60);

    // Only jump to the search box where there is a real keyboard, so phones show the list first.
    if (search && !search.parentNode.hidden && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) search.focus();
  }

  // ---- Choosing ----

  function showChoice(wrapper, options, selection) {
    options.forEach(function (option, index) {
      var box = wrapper.querySelector('.kp-pp--dropdown[data-kp-pp-opt="' + index + '"]');
      var label = box ? box.querySelector('[data-kp-pp-current]') : null;
      if (label) label.textContent = selection[index];

      var holder = holderOf(wrapper, index);
      if (holder) {
        each(holder.querySelectorAll('[data-kp-pp-value]'), function (button) {
          var on = button.getAttribute('data-kp-pp-value') === selection[index];
          button.classList.toggle('is-selected', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      each(wrapper.querySelectorAll('[data-selected-value-for-option][data-option-name="' + option.key + '"]'), function (span) {
        span.textContent = selection[index];
      });
    });

    setTitle(wrapper, selection);
  }

  // Show the new price and main photo at once; the theme confirms them a moment later.
  function preview(wrapper, detail) {
    if (!detail) return;

    var product = wrapper.closest('.product') || document;
    var priceText = money(detail.price);
    var onSale = detail.compare > detail.price;

    if (priceText) {
      each(product.querySelectorAll('.product__price'), function (block) {
        var price = block.querySelector('[data-price]');
        var compare = block.querySelector('[data-compare-price]');
        var discount = block.querySelector('[data-discount-display]');

        if (price) price.innerHTML = priceText;
        if (compare) compare.innerHTML = onSale ? money(detail.compare) : '';

        if (discount) {
          discount.setAttribute('data-hidden', onSale ? 'false' : 'true');
          discount.setAttribute('data-has-discount', onSale ? 'true' : 'false');

          var badge = discount.querySelector('.displayed-discount');
          if (badge && onSale && /^\s*Save\b/i.test(badge.textContent)) {
            badge.textContent = 'Save ' + plainMoney(detail.compare - detail.price);
          }
        }
      });
    }

    if (detail.image) {
      var img = product.querySelector('.product__media img.image__img');
      var slider = product.querySelector('.product__media .scroll-slider__slider');

      if (img) {
        img.removeAttribute('srcset');
        img.setAttribute('src', detail.image + (detail.image.indexOf('?') > -1 ? '&' : '?') + 'width=900');
      }

      try {
        if (slider && slider.scrollLeft > 0) slider.scrollTo({ left: 0, behavior: 'auto' });
      } catch (e) {}
    }
  }

  // When the new combination does not exist, move the other card / button options to one that does.
  function settle(wrapper, options, selection, changed) {
    var chain = Promise.resolve();

    options.forEach(function (option, index) {
      if (index === changed || (option.kind !== 'cards' && option.kind !== 'pills')) return;

      chain = chain.then(function () {
        return mapLater(wrapper, options, selection, index).then(function (map) {
          if (!map || map[selection[index]]) return;

          var fallback = FALLBACKS.filter(function (value) {
            return !!map[value];
          })[0];
          var first = option.values.filter(function (value) {
            return !!map[value];
          })[0];

          if (fallback || first) selection[index] = fallback || first;
        });
      });
    });

    return chain;
  }

  function choose(wrapper, index, value) {
    var options = optionsOf(wrapper);
    if (!options[index]) return;

    var selection = selectionOf(options);
    if (selection[index] === value) return;
    selection[index] = value;

    var ticket = {};
    wrapper.kpTicket = ticket;

    // Show the choice on the picker before anything else.
    showChoice(wrapper, options, selection);

    settle(wrapper, options, selection, index)
      .then(function () {
        return mapLater(wrapper, options, selection, index);
      })
      .then(function (map) {
        if (wrapper.kpTicket !== ticket) return;

        var fresh = optionsOf(wrapper);
        if (fresh.length !== options.length) return;

        var first = null;
        fresh.forEach(function (option, k) {
          if (option.select.value !== selection[k]) {
            option.select.value = selection[k];
            if (!first) first = option.select;
          }
        });

        if (!first) {
          showChoice(wrapper, fresh, selection);
          return;
        }

        fresh.forEach(function (option, k) {
          if (option.kind === 'cards' || option.kind === 'pills') refreshValues(wrapper, fresh, k);
        });
        showChoice(wrapper, fresh, selection);
        preview(wrapper, map ? map[selection[index]] : null);

        // One change event: the theme reads every select and loads the matching variant.
        first.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  // ---- Build ----

  function buildDropdown(option, index) {
    var box = el('div', 'kp-pp kp-pp--dropdown');
    box.setAttribute('data-kp-pp-opt', index);

    var button = el('button', 'kp-pp__button');
    button.type = 'button';
    button.setAttribute('data-kp-pp-open', '');
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    var current = el('span', '', option.select.value);
    current.setAttribute('data-kp-pp-current', '');
    button.appendChild(current);
    box.appendChild(button);

    var panel = el('div', 'kp-pp__panel');
    panel.setAttribute('data-kp-pp-panel', '');
    panel.hidden = true;

    var searchBox = el('div', 'kp-pp__search');
    var search = el('input', 'kp-pp__search-input');
    search.type = 'search';
    search.placeholder = 'Search';
    search.setAttribute('aria-label', 'Search');
    search.setAttribute('autocomplete', 'off');
    search.setAttribute('autocorrect', 'off');
    search.setAttribute('autocapitalize', 'off');
    search.setAttribute('spellcheck', 'false');
    search.setAttribute('data-kp-pp-search', '');
    searchBox.appendChild(search);
    searchBox.hidden = option.values.length <= SEARCH_OVER;
    panel.appendChild(searchBox);

    var list = el('div', 'kp-pp__list');
    list.setAttribute('role', 'listbox');
    list.setAttribute('data-kp-pp-list', '');
    panel.appendChild(list);
    box.appendChild(panel);

    return box;
  }

  function build(wrapper) {
    var options = optionsOf(wrapper);
    if (!options.length) return;

    // The theme has just re-drawn the title along with the picker, so set it again.
    setTitle(wrapper, selectionOf(options));

    if (wrapper.querySelector('[data-kp-pp-built]')) return;

    wrapper.classList.add('kp-pp-on');
    document.documentElement.classList.add('kp-pp-active');

    options.forEach(function (option, index) {
      option.row.setAttribute('data-kp-pp-built', '');
      option.row.classList.add('kp-pp-row');

      if (option.kind === 'hidden') {
        option.row.classList.add('kp-pp-row--hidden');
        return;
      }

      if (option.kind === 'dropdown') {
        option.row.appendChild(buildDropdown(option, index));
        return;
      }

      var box = el('div', 'kp-pp kp-pp--values');
      var holder = el('div', option.kind === 'cards' ? 'kp-pp__cards' : 'kp-pp__pills');
      if (option.kind === 'cards' && TALL_PHOTO_OPTIONS.indexOf(option.name) < 0) holder.classList.add('kp-pp__cards--square');
      holder.setAttribute('data-kp-pp-values', '');
      holder.setAttribute('data-kp-pp-opt', index);
      box.appendChild(holder);
      option.row.appendChild(box);

      refreshValues(wrapper, options, index);
    });
  }

  function bind(wrapper) {
    if (wrapper.kpBound) return;
    wrapper.kpBound = true;

    wrapper.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;

      var opener = target.closest('[data-kp-pp-open]');
      if (opener) {
        var box = opener.closest('.kp-pp--dropdown');
        if (openBox === box) closePanel(false);
        else openPanel(wrapper, box);
        return;
      }

      var pick = target.closest('[data-kp-pp-pick]');
      if (pick) {
        var pickBox = pick.closest('.kp-pp--dropdown');
        var value = pick.getAttribute('data-kp-pp-pick');
        closePanel(true);
        choose(wrapper, parseInt(pickBox.getAttribute('data-kp-pp-opt'), 10), value);
        return;
      }

      var item = target.closest('[data-kp-pp-value]');
      if (item) {
        var holder = item.closest('[data-kp-pp-values]');
        choose(wrapper, parseInt(holder.getAttribute('data-kp-pp-opt'), 10), item.getAttribute('data-kp-pp-value'));
      }
    });

    wrapper.addEventListener('input', function (event) {
      if (!event.target.matches || !event.target.matches('[data-kp-pp-search]')) return;
      drawList(wrapper, event.target.closest('.kp-pp--dropdown'), event.target.value);
    });

    wrapper.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openBox && wrapper.contains(openBox)) {
        event.stopPropagation();
        closePanel(true);
        return;
      }

      if (!event.target.matches || !event.target.matches('[data-kp-pp-search]')) return;

      var box = event.target.closest('.kp-pp--dropdown');

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(box, (box.kpActive === undefined ? -1 : box.kpActive) + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(box, (box.kpActive || 0) - 1);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        var buttons = optionButtons(box);
        var pick = buttons[box.kpActive > -1 ? box.kpActive : 0];
        if (pick) pick.click();
      }
    });

    // The theme replaces the contents of this area after every variant change.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (!wrapper.querySelector('[data-kp-pp-built]')) {
          if (openBox && !document.documentElement.contains(openBox)) openBox = null;
          build(wrapper);
        }
      }).observe(wrapper, { childList: true });
    }
  }

  function initAll() {
    each(document.querySelectorAll('.product__variants-wrapper'), function (wrapper) {
      if (!optionsOf(wrapper).length) return;
      bind(wrapper);
      build(wrapper);
    });
  }

  document.addEventListener('pointerdown', function (event) {
    if (!openBox) return;
    if (openBox.contains(event.target)) return;
    closePanel(false);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
